import React, { useState, useEffect } from 'react';
import { Button, Dropdown, Header, Loader, Modal } from 'semantic-ui-react';
import agent from '../../app/api/agent';
import { toast } from 'react-toastify';

const reportoptions = [
  { key: 1, text: 'Visible Title', value: 'Visible Title' },
  { key: 2, text: 'Hidden Title', value: 'Hidden Title' },
];

const ProductionTitleDeactivation = () => {
  const [selectedTitle, setSelectedTitle] = useState<string>('');
  const [assignTitleCode, setAssignTitleCode] = useState<{ key: string; text: string; value: string }[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedReport, setSelectedReport] = useState<string>(''); 
  const [visibleTitle, setVisibleTitle] = useState<string>('');
  const [hiddenTitle, setHiddenTitle] = useState<string>('');
  const [hideModal, setHideModal] = useState<boolean>(false);
  const [reopenModal, setReopenModal] = useState<boolean>(false);
  const [cancelFlag, setCancelFlag] = useState<boolean>(false);  

  useEffect(() => {
    const fetchTitleCodes = async () => {
      try {
        const response = await agent.Restoration.titleCodeforCR();
        setAssignTitleCode(response.data);
      } catch (error) {
        toast.error('Error fetching title code');
      }
    };

    fetchTitleCodes();
  }, []); 

  const handleChangeTitle = async (e: React.SyntheticEvent<HTMLElement>, data: any) => {
    setSelectedTitle(data.value as string);
  };

  const handleChangeReport = (e: React.SyntheticEvent<HTMLElement>, data: any) => {
    setSelectedReport(data.value);
  };

  const handleViewReport = async () => {
    setLoading(true);
    setCancelFlag(false);  
    setVisibleTitle('');   
    setHiddenTitle('');    

    if (selectedReport === 'Visible Title') {
      try {
        const response = await agent.Restoration.assetOpenCR(selectedTitle);
        if (cancelFlag) return '';  
        setVisibleTitle(response.data);  
        setReopenModal(true);
      } catch (error) {
        if (!cancelFlag) {  
          toast.error('Error fetching asset data');
        }
      } finally {
        setLoading(false);
      }
    } else if (selectedReport === 'Hidden Title') {
      try {
        const response = await agent.Restoration.assetHideCR(selectedTitle);
        if (cancelFlag) return '';  
        setHiddenTitle(response.data);
        setHideModal(true);
      } catch (error) {
        if (!cancelFlag) {  
          toast.error('Error fetching asset data');
        }
      } finally {
        setLoading(false);
      }
    }
  };

  const handleHideModal = () => {
    setCancelFlag(true);  
    setHideModal(false);
  };

  const handleReopenModal = () => {
    setCancelFlag(true);  
    setReopenModal(false);
  };

  const handleConfirmHide = () => {
    setHideModal(false);
  };

  const handleConfirmReopen = () => {
    setReopenModal(false);
  };

  return (
    <div className="title_wise_cutlistreport">
      <Header>Production Title Deactivation</Header>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
        <div style={{ marginRight: '10px' }}>
          <label style={{ fontWeight: 'bold' }}>Process Type</label>
          <Dropdown
            clearable
            placeholder="Select an option"
            fluid
            selection
            options={reportoptions}
            value={selectedReport}
            onChange={handleChangeReport}
            style={{ width: '250px' }}
          />
        </div>
        {selectedReport && (
            <div style={{ marginRight: '10px' }}>
                  <label style={{ fontWeight: 'bold' }}>Title Code</label>
                  <Dropdown
                    clearable
                    placeholder="Select an option"
                    fluid
                    selection
                    options={assignTitleCode}
                    value={selectedTitle}
                    onChange={handleChangeTitle}
                    style={{ width: '250px' }}
                  />
            </div>
        )}
        {selectedTitle && selectedReport && (
          <div style={{ marginRight: "10px", alignSelf: 'end' }}>
            <Button onClick={handleViewReport} primary>Submit</Button>
          </div>
        )}
      </div>
      {loading ? (
        <Loader active inline='centered' />
      ) : (
        <div>
          <Modal open={hideModal} onClose={handleHideModal}>
            <Modal.Header>Hide Asset</Modal.Header>
            <Modal.Content>
              <p>Are you sure you want to hide this title {selectedTitle}?</p>
            </Modal.Content>
            <Modal.Actions>
              <Button onClick={handleHideModal} negative>Cancel</Button>
              <Button onClick={handleConfirmHide} positive>Confirm</Button>
            </Modal.Actions>
          </Modal>
          <Modal open={reopenModal} onClose={handleReopenModal}>
            <Modal.Header>Reopen Asset</Modal.Header>
            <Modal.Content>
              <p>Are you sure you want to reopen this title {selectedTitle}?</p>
            </Modal.Content>
            <Modal.Actions>
              <Button onClick={handleReopenModal} negative>Cancel</Button>
              <Button onClick={handleConfirmReopen} positive>Confirm</Button>
            </Modal.Actions>
          </Modal>
          {selectedReport === 'Visible Title' && selectedTitle && visibleTitle && cancelFlag === false ? (
            <p style={{fontWeight: 'bold', textAlign: 'center', marginTop: '50px'}}>{visibleTitle}</p>
          ): null}
          {selectedReport === 'Hidden Title' && selectedTitle && hiddenTitle && cancelFlag === false ? (
            <p style={{fontWeight: 'bold', textAlign: 'center', marginTop: '50px'}}>{hiddenTitle}</p>
          ): null}
        </div>
      )}
    </div>
  );
};

export default ProductionTitleDeactivation;
